import { ApplicationConfig, APP_INITIALIZER, inject, provideBrowserGlobalErrorListeners, LOCALE_ID } from '@angular/core';
import { provideRouter, withComponentInputBinding } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { registerLocaleData } from '@angular/common';
import localeEs from '@angular/common/locales/es';
import { appRoutes } from './app.routes';

// Register Spanish locale
registerLocaleData(localeEs);
import { authInterceptor, AuthService } from '@com.maessa.payroll.frontend/auth';
import { siteInterceptor } from '@com.maessa.payroll.frontend/site-context';
import {
  AuthApiService,
  WorkSheetApiService,
  TimeEntryApiService,
  EmployeeApiService,
  TeamApiService,
  SiteApiService,
  OottApiService,
  ReportApiService,
  HoursApiService,
  AdminApiService,
} from '@com.maessa.payroll.frontend/api-services';
import { environment } from '../environments/environment';

export const appConfig: ApplicationConfig = {
  providers: [
    { provide: LOCALE_ID, useValue: 'es' },
    provideBrowserGlobalErrorListeners(),
    provideAnimationsAsync(),
    provideHttpClient(withInterceptors([authInterceptor, siteInterceptor])),
    provideRouter(appRoutes, withComponentInputBinding()),
    {
      provide: APP_INITIALIZER,
      useFactory: () => {
        const authService = inject(AuthService);
        const authApiService = inject(AuthApiService);
        const workSheetApiService = inject(WorkSheetApiService);
        const timeEntryApiService = inject(TimeEntryApiService);
        const employeeApiService = inject(EmployeeApiService);
        const teamApiService = inject(TeamApiService);
        const siteApiService = inject(SiteApiService);
        const oottApiService = inject(OottApiService);
        const reportApiService = inject(ReportApiService);
        const hoursApiService = inject(HoursApiService);
        const adminApiService = inject(AdminApiService);

        return () => {
          // Configure baseUrl for all API services
          authApiService.setBaseUrl(environment.apiUrl);
          workSheetApiService.setBaseUrl(environment.apiUrl);
          timeEntryApiService.setBaseUrl(environment.apiUrl);
          employeeApiService.setBaseUrl(environment.apiUrl);
          teamApiService.setBaseUrl(environment.apiUrl);
          siteApiService.setBaseUrl(environment.apiUrl);
          oottApiService.setBaseUrl(environment.apiUrl);
          reportApiService.setBaseUrl(environment.apiUrl);
          hoursApiService.setBaseUrl(environment.apiUrl);
          adminApiService.setBaseUrl(environment.apiUrl);

          authService.setAuthApiService(authApiService);
          const init$ = authService.initFromToken();
          return init$ ? init$ : Promise.resolve();
        };
      },
      multi: true,
    },
  ],
};
